var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 7.25813C16.542 7.25813 7.25813 16.542 7.25813 28C7.25813 39.458 16.542 48.7419 28 48.7419C39.458 48.7419 48.7419 39.458 48.7419 28C48.7419 16.542 39.458 7.25813 28 7.25813ZM5.57812 28C5.57812 15.6142 15.6142 5.57812 28 5.57812C40.3858 5.57812 50.4219 15.6142 50.4219 28C50.4219 40.3858 40.3858 50.4219 28 50.4219C15.6142 50.4219 5.57812 40.3858 5.57812 28Z",
    fill: "#326164"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2236 12.3876C22.0463 8.42174 24.7342 5.57812 27.9999 5.57812C31.2657 5.57812 33.9536 8.42174 35.7763 12.3876C37.6324 16.4259 38.7581 21.9463 38.7581 28C38.7581 34.0538 37.6324 39.5741 35.7763 43.6124C33.9536 47.5783 31.2657 50.4219 27.9999 50.4219C24.7342 50.4219 22.0463 47.5783 20.2236 43.6124C18.3675 39.5741 17.2418 34.0538 17.2418 28C17.2418 21.9463 18.3675 16.4259 20.2236 12.3876ZM21.7501 13.0892C20.0164 16.8613 18.9218 22.1319 18.9218 28C18.9218 33.8681 20.0164 39.1388 21.7501 42.9109C23.5171 46.7555 25.7882 48.7419 27.9999 48.7419C30.2117 48.7419 32.4828 46.7555 34.2498 42.9109C35.9835 39.1388 37.0781 33.8681 37.0781 28C37.0781 22.1319 35.9835 16.8613 34.2498 13.0892C32.4828 9.24451 30.2117 7.25813 27.9999 7.25813C25.7882 7.25813 23.5171 9.24451 21.7501 13.0892Z",
    fill: "#326164"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32812 20.4181C7.32812 19.9542 7.70421 19.5781 8.16812 19.5781H47.8319C48.2958 19.5781 48.6719 19.9542 48.6719 20.4181C48.6719 20.882 48.2958 21.2581 47.8319 21.2581H8.16812C7.70421 21.2581 7.32812 20.882 7.32812 20.4181Z",
    fill: "#326164"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32812 35.5819C7.32812 35.118 7.70421 34.7419 8.16812 34.7419H47.8319C48.2958 34.7419 48.6719 35.118 48.6719 35.5819C48.6719 36.0459 48.2958 36.4219 47.8319 36.4219H8.16812C7.70421 36.4219 7.32812 36.0459 7.32812 35.5819Z",
    fill: "#326164"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/NoResults.550410bc98b9b13423660f7eaf2c0b6e.svg";
export { ForwardRef as ReactComponent };